<template>
  <div :id="elementId">
    <a v-if="useLink"
       :target="linkTarget"
       :rel="linkRel"
       :href="roleLink">
      {{ role.roleId }}
    </a>
    <div v-else class="d-inline">
      {{ role.roleId }}
    </div>
    <span v-if="showSecondaryDisplay"
          class="space-left text-capitalize">
      ({{secondaryDisplay}})
    </span>
  </div>
</template>

<script>
export default {
  props: {
    /* The role being displayed. */
    role: {
      type: Object,
      required: true,
    },
    /* The type of role represented. One of [administrators, managers, contacts, viewers] */
    roleType: {
      type: String,
      required: true,
    },
    /* Optional flag stating whether the displayed role should be a link (to another group, person search etc.)
       * Default is true. */
    withLink: {
      type: Boolean,
      required: false,
      default: true,
    },
    /* Optional flag stating whether the displayed role should include a secondary display attribute. Default is true.
       * E.g. Displaying person, the secondary display would be their display name. */
    showSecondaryDisplay: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    useLink() {
      return (this.withLink && (this.role.kind === 'person' || this.role.kind === 'group') && this.role.hasAccount);
    },
    elementId() {
      let identifier = '';
      if (this.useLink) {
        identifier += 'lnk-';
      }
      identifier = `${identifier}${this.role.kind}-${this.roleType}-${this.role.roleId}`;
      return identifier;
    },
    roleLink() {
      if (this.withLink && (this.role.kind === 'person' || this.role.kind === 'group')) {
        if (this.role.kind === 'person') {
          return `http://search.vt.edu/search/people.html?q=${this.role.pid}`;
        } else if (this.role.kind === 'group') {
          return `/group/${this.role.uugid}`;
        }
      }
    },
    linkTarget() {
      if (this.withLink && this.role.kind === 'person') {
        return '_blank';
      }
      return '';
    },
    linkRel() {
      if (this.withLink && this.role.kind === 'person') {
        return 'noopener noreferrer nofollow';
      }
      return '';
    },
    secondaryDisplay() {
      if (this.role.kind === 'person') {
        return this.role.displayName;
      }
      if (this.role.kind === 'service') {
        return 'Service';
      }
      if (this.role.kind === 'group') {
        return 'Group';
      }
    },
  },
};
</script>

<style scoped>
  .space-left {
    margin-left: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/DisplayRole.vue